import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import { CustomButton } from "../../../../Forms"
import CustomBody from "../../CustomBody/index";
import ConfirmationComponent from "../../../../atomic/Confirmation";
import { ModalConfirmationTsx } from "../../../../Modals"
import AddressCard from "./AddressCard";

//Assets
import Location from "../../../../../images/location.png";
import Trash from "../../../../../images/trash.png";

//Interfaces
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  ListAddresses,
  loading,
  openDeleteConfirmation,
  openConfirmation,
  choosenAddress,
  setDefaultHandler,
  deleteAddressHandler,
  onBack,
  addEditAddress,
  cancelDeleteAddressHandler,
  cancelDefaultHandler,
  deleteAddressAction,
  updateDefaultAddressHandler,
  setChoosenAddress,
  confirmHandler
}) => {
  return (
    <CustomBody loading={loading} withBack backAction={onBack}>
      <>
        <div className="select-address-body">
          <p className="header">Select Pickup Address</p>

          <AddressCard
            ListAddresses={ListAddresses}
            setDefaultHandler={setDefaultHandler}
            deleteAddressHandler={deleteAddressHandler}
            choosenAddress={choosenAddress}
            setChoosenAddress={setChoosenAddress}
            addEditAddress={addEditAddress}
          />

          <div className="button-wrapper">
            <CustomButton
              className="add-address-btn"
              text={"Add Address"}
              onClick={addEditAddress}
              disabled={false}
            />
            <CustomButton
              className="confirm-btn"
              text={"Confirm"}
              disabled={!choosenAddress}
              onClick={confirmHandler}
            />
          </div>
        </div>
        {
          openDeleteConfirmation &&
          <ModalConfirmationTsx onHide={cancelDeleteAddressHandler} show={openDeleteConfirmation}>
            <ConfirmationComponent
              className={"custom-confirmation-modal"}
              img={Trash}
              title={"Delete Address"}
              info={"Are you sure want to delete this address ?"}
              cancelText={"Cancel"}
              confirmationText={"Yes"}
              cancelAction={cancelDeleteAddressHandler}
              confirmAction={deleteAddressAction}
            />
          </ModalConfirmationTsx>
        }
        {
          openConfirmation &&
          <ModalConfirmationTsx onHide={cancelDefaultHandler} show={openConfirmation}>
            <ConfirmationComponent
              className={"custom-confirmation-modal"}
              img={Location}
              title={"Set default address"}
              info={"Are you sure want to this as default address?"}
              cancelText={"Cancel"}
              confirmationText={"Yes"}
              cancelAction={cancelDefaultHandler}
              confirmAction={updateDefaultAddressHandler}
            />
          </ModalConfirmationTsx>
        }
      </>
    </CustomBody>
  )
};

export default Component;